import PersonalWorkout from './PersonalWorkout';

export default PersonalWorkout;
